module.exports = __webpack_public_path__ + "img/adv-img.0dc8be0e.png";